import type { ToolTypeFilter } from '@/features/admin/ui/ToolsTable';

export const TYPE_FILTER_OPTIONS = [
  { value: 'all', labelKey: 'admin.tools.all' },
  { value: 'system', labelKey: 'admin.tools.system' },
  { value: 'user', labelKey: 'admin.tools.custom' },
  { value: 'archived', labelKey: 'admin.tools.archived' },
] as const satisfies readonly { value: ToolTypeFilter; labelKey: string }[];

export const TYPE_FILTER_STORAGE_KEY = 'admin-tools-type-filter';

export const DEFAULT_TYPE_FILTER: ToolTypeFilter = 'all';

export function getStoredTypeFilter(): ToolTypeFilter {
  const stored = localStorage.getItem(TYPE_FILTER_STORAGE_KEY);
  if (stored === 'all' || stored === 'system' || stored === 'user' || stored === 'archived') {
    return stored;
  }
  return DEFAULT_TYPE_FILTER;
}

export function storeTypeFilter(value: ToolTypeFilter) {
  localStorage.setItem(TYPE_FILTER_STORAGE_KEY, value);
}

export function filterToolsByType<
  T extends { source?: 'system' | 'user'; builtAgent?: { archived?: boolean } },
>(tools: T[], typeFilter: ToolTypeFilter): T[] {
  const archived = (tool: T) => tool.builtAgent?.archived === true;
  if (typeFilter === 'archived') return tools.filter(archived);
  const active = tools.filter((tool) => !archived(tool));
  if (typeFilter === 'all') return active;
  if (typeFilter === 'user') return active.filter((tool) => tool.source === 'user');
  return active.filter((tool) => tool.source !== 'user');
}
